export const setActiveStudyId = (study_id) => {
  return { type: "set_active_study_id", payload: study_id };
};
